import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

// Initialize Stripe with your publishable key
// TODO: Add REACT_APP_STRIPE_PUBLISHABLE_KEY to your environment variables
// For now, using a placeholder - replace with your actual Stripe publishable key
const getStripePublishableKey = () => {
  const env = (process.env.REACT_APP_ENV || "stag").toLowerCase();

  // Environment-specific Stripe keys (replace with your actual keys)
  const stripeKeys = {
    dev:
      process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_DEV ||
      "pk_test_dev_key_here",
    stag:
      process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_STAG ||
      "pk_test_stag_key_here",
    prod:
      process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_PROD ||
      "pk_live_prod_key_here",
  };

  return stripeKeys[env] || stripeKeys.stag;
};

const stripePromise = loadStripe(getStripePublishableKey());

const StripeProvider = ({ children }) => {
  return <Elements stripe={stripePromise}>{children}</Elements>;
};

export default StripeProvider;
